import {http} from "../utils/http";

export const getWorkforceDashboardData = async (data) => {
    try {
        return await http.get("/Dashboard/workforce", {params: data});
    } catch (error) {
    }
};

export const createWorkforceDashboardData = async (id, data) => {
    try {
        return await http.post(`Workforce/upsert/${id}`, data);
    } catch (error) {
    }
};

export const createDraftWorkforceDashboardData = async (id, data) => {
    try {
        return await http.post(`Workforce/upsert-draft/${id}`, data);
    } catch (error) {
    }
};

export const getDataForWorkforceListing = async (data) => {
    try {
        return await http.get("/Workforce/list", {params: data});
    } catch (error) {
    }
};

export const getDataForWorkforceExcelDownload = async (data) => {
    try {
        return await http.get("/Workforce/all", {params: data});
    } catch (error) {
    }
};

export const getDataForWorkforceDetails = async (id) => {
    try {
        return await http.get(`/Workforce/${id}`);
    } catch (error) {
    }
};

export const completeWorkforceCase = async (id) => {
    try {
        return await http.post(`/Workforce/completed/${id}`);
    } catch (error) {
    }
};

export const cancelledWorkforceCase = async (id) => {
    try {
        return await http.post(`/Workforce/cancelled/${id}`);
    } catch (error) {
    }
};

export const deleteWorkforceCase = async (ids) => {
    try {
        return await http.delete(`/Workforce`, {
            data: {
                ids: ids
            }
        });
    } catch (error) {
    }
};


